import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "inventory",
  "use": "inventory-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"inventory\"><path d=\"M19.723 16.373 11.451 8.1c.818-2.09.363-4.545-1.364-6.273C8.269.01 5.54-.355 3.36.645l3.909 3.91L4.54 7.282l-4-3.91c-1.09 2.183-.636 4.91 1.182 6.728 1.728 1.727 4.182 2.182 6.273 1.364l8.273 8.272a.879.879 0 0 0 1.272 0l2.091-2.09c.455-.364.455-1 .091-1.273z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol